<div hidden>
    <ng-template #loading>
        <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
    </ng-template>
</div>
<div *ngIf="attachment?.SafeResource; else loading">
    <div *ngIf="isImage(attachment)">
        <img
            [src]="attachment?.SafeResource"
            style="max-width: 80vw; max-height: 80vh; border: none"
        />
    </div>
</div>
